<div class="video-thumbnail-container">
  <div class="video-thumbnail">
    @if (isLoading()) {
    <div class="empty-thumbnail skeleton"></div>
    } @else {
    <img [src]="videoThumbnailUrl" [alt]="video.title || ''" />
    }
  </div>
</div>
